import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-body1" }

import SEditor from 'SharedComponents/ui/Input/SEditor.vue';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';

export interface Props extends PropValue<null | string> {
  readonly?: boolean;
  label: string;
}

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'WysiWygParameter', components: { SEditor } },
  __name: 'Wysiwyg',
  props: {
    readonly: { type: Boolean, default: false },
    label: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emit = __emit;
const { innerValue, emitValue } = useValue(props, emit);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.label), 1),
    _createVNode(SEditor, {
      modelValue: _unref(innerValue),
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
        _unref(emitValue)
      ],
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly", "onUpdate:modelValue"])
  ]))
}
}

})